import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
export var buildOAuthInitUrl = function buildOAuthInitUrl(params) {
  var searchParams = new URLSearchParams();

  if (params) {
    Object.entries(params).forEach(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          value = _ref2[1];

      if (value != null && value !== '') {
        searchParams.set(key, String(value));
      }
    });
  }

  var query = searchParams.toString(); // Same-origin keeps the server session (wps_ owner) used for guest reserves.

  return "/webapi/oauth/init".concat(query ? "?".concat(query) : '');
};